import React, { FC } from 'react';
import { CheckboxProps } from 'react-uforms';
import { WithStyle } from '@ch/common/utils';
import { IconCheck } from '@ch/common/components/icon';
import { FormCheckboxStyled, FormCheckboxInput, FormCheckboxLabel, FormCheckboxIcon } from './checkbox.styled';
import { CheckboxStyleProps } from './types';
import { FormCheckboxToggle } from './toggle';

export const FormCheckbox: FC<CheckboxStyleProps & CheckboxProps> & WithStyle = ({
  ref: _ref,
  as: _as,
  children,
  $size,
  $variant,
  $m,
  $toggle,
  ...rest
}) => {
  return (
    <FormCheckboxStyled $m={$m}>
      <FormCheckboxInput {...rest} />
      <FormCheckboxLabel {...{ $size, $variant }}>
        {$toggle ? (
          <FormCheckboxToggle />
        ) : (
          <FormCheckboxIcon>
            <IconCheck $size={10} />
          </FormCheckboxIcon>
        )}
        {children}
      </FormCheckboxLabel>
    </FormCheckboxStyled>
  );
};

FormCheckbox.defaultProps = {
  $size: 'md',
  $variant: 'default',
  disabled: false,
  children: 'Enter',
};
